import BlogArticleCard from './BlogArticleCard/BlogArticleCard.jsx'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../../utility/'
import { isInstitutional } from '../../../../global/authentication/authentication-manager.js'

const BlogArticleCardList = (props) => {
  const { items = [], itemsVisible, taxonomies = [] } = props
  const interactionStudioDivRef = useRef(null)
  const [cards, setCards] = useState(items)
  const hasInteractionStudioDiv =
    interactionStudioDivRef.current &&
    interactionStudioDivRef.current.getElementsByTagName('div')
  const numberOfVisibleItems = hasInteractionStudioDiv?.length
    ? itemsVisible - 1
    : itemsVisible

  useEffect(() => {
    if (items.length !== cards.length || hasInteractionStudioDiv) {
      setCards(items)
    }
  }, [interactionStudioDivRef, items])

  return (
    <>
      {cards.map((item, i) => {
        if (i >= numberOfVisibleItems) {
          return
        }
        return (
          <React.Fragment key={i}>
            <BlogArticleCard
              key={item.document.getId()}
              item={item}
              index={i}
              taxonomies={taxonomies}
            >
              <BrManageContentButton content={item.document} />
            </BlogArticleCard>
            {!isInstitutional() &&
            ((cards.length > 1 && i === 1) ||
              (cards.length === 1 && i === 0)) ? (
              <div
                className="interaction-studio-div"
                data-interaction-studio="IS004"
                ref={interactionStudioDivRef}
              ></div>
            ) : (
              ''
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}

BlogArticleCardList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  itemsVisible: PropTypes.number.isRequired,
}

function BlogArticeCardListErrorBoundary(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? <p>Error in BlogArticleCardList component</p> : null
      }
    >
      <BlogArticleCardList {...props}></BlogArticleCardList>
    </ErrorBoundary>
  )
}

export { BlogArticeCardListErrorBoundary as BlogArticleCardList }
